import type { ReactNode } from 'react';
import { Button } from '../button';
import { Col } from '../col';
import { DateTimeInfo, type TimeInfo } from '../date-time-info';
import { Dropdown, type MenuProps as MenuProperties } from '../dropdown';
import { More2LineIcon } from '../icons';
import { Row } from '../row';
import { Tag, type TagProperties } from '../tag';
import { Title } from '../typography';
import { MembersCount } from './members-count';

type P = {
  actions?: MenuProperties['items'];
  children?: ReactNode;
  extra?: ReactNode;
  isStrikeThrough?: boolean;
  membersCount?: number;
  secondaryTag?: ReactNode;
  tags: TagProperties | TagProperties[];
  timeInfo?: TimeInfo;
  title: ReactNode;
};

const HeaderContent = ({ actions, children, extra, isStrikeThrough, membersCount, tags, timeInfo, title }: P) => {
  const tagItems = Array.isArray(tags) ? tags : [tags];

  return (
    <Row className="header-content" gutter={[0, 'ms']}>
      <Col span={24}>
        <Row justify="space-between">
          <Col>
            {tagItems.length > 0 ? (
              <Row gutter={['xs', 0]}>
                {tagItems.map((tag, index) => (
                  // eslint-disable-next-line react/no-array-index-key -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
                  <Col key={index}>
                    <Tag {...tag}>{tag.children}</Tag>
                  </Col>
                ))}
              </Row>
            ) : null}
          </Col>

          {!extra && !actions ? null : (
            <Col>
              <Row gutter="xs">
                {extra ? <Col>{extra}</Col> : null}

                {/* eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases */}
                {actions && actions?.length > 0 ? (
                  <Col alignItems="center">
                    <Dropdown menu={{ items: actions }} trigger={['click']}>
                      <Button icon={<More2LineIcon />} type="link-secondary" />
                    </Dropdown>
                  </Col>
                ) : null}
              </Row>
            </Col>
          )}
        </Row>
      </Col>

      <Col flex={1} span={24}>
        <Row gutter={[0, 'xs']}>
          <Col span={24}>
            {typeof title === 'string' ? (
              <Title ellipsis={{ rows: 4, tooltip: true }} level={2}>
                {title}
              </Title>
            ) : (
              title
            )}
          </Col>

          {timeInfo ? (
            <Col span={24}>
              <DateTimeInfo isStrikeThrough={isStrikeThrough} timeInfo={timeInfo} />
            </Col>
          ) : null}

          {membersCount ? (
            <Col span={24}>
              <MembersCount membersCount={membersCount} />
            </Col>
          ) : null}

          <Col span={24}>{children}</Col>
        </Row>
      </Col>
    </Row>
  );
};

export default HeaderContent;
